"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require("../../utils"),
    mixin = _require.mixin;

var NodeImpl = require("./Node-impl").implementation;

var ChildNodeImpl = require("./ChildNode-impl").implementation;

var NonDocumentTypeChildNodeImpl = require("./NonDocumentTypeChildNode-impl").implementation;

var DOMException = require("domexception");

var _require2 = require("../node-type"),
    TEXT_NODE = _require2.TEXT_NODE;

var CharacterDataImpl = /*#__PURE__*/function (_NodeImpl) {
  _inherits(CharacterDataImpl, _NodeImpl);

  var _super = _createSuper(CharacterDataImpl);

  function CharacterDataImpl(args, privateData) {
    var _this;

    _classCallCheck(this, CharacterDataImpl);

    _this = _super.call(this, args, privateData);
    _this._data = privateData.data;
    return _this;
  }

  _createClass(CharacterDataImpl, [{
    key: "substringData",
    value: function substringData(offset, count) {
      var length = this.length;

      if (offset > length) {
        throw new DOMException("The index is not in the allowed range.", "IndexSizeError");
      }

      if (offset + count > length) {
        return this._data.substring(offset);
      }

      return this._data.substring(offset, offset + count);
    }
  }, {
    key: "appendData",
    value: function appendData(data) {
      this.replaceData(this.length, 0, data);
    }
  }, {
    key: "insertData",
    value: function insertData(offset, data) {
      this.replaceData(offset, 0, data);
    }
  }, {
    key: "deleteData",
    value: function deleteData(offset, count) {
      this.replaceData(offset, count, "");
    }
  }, {
    key: "replaceData",
    value: function replaceData(offset, count, data) {
      var length = this.length;

      if (offset > length) {
        throw new DOMException("The index is not in the allowed range.", "IndexSizeError");
      }

      if (offset + count > length) {
        count = length - offset;
      }

      var start = this._data.substring(0, offset);

      var end = this._data.substring(offset + count);

      this._data = start + data + end; // TODO: range stuff

      if (this.nodeType === TEXT_NODE && this.parentNode) {
        this.parentNode._childTextContentChangeSteps();
      }
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(data) {
      this.replaceData(0, this.length, data);
    }
  }, {
    key: "length",
    get: function get() {
      return this._data.length;
    }
  }]);

  return CharacterDataImpl;
}(NodeImpl);

mixin(CharacterDataImpl.prototype, NonDocumentTypeChildNodeImpl.prototype);
mixin(CharacterDataImpl.prototype, ChildNodeImpl.prototype);
module.exports = {
  implementation: CharacterDataImpl
};